<template>
    <div id="app">
        <keep-alive>
            <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive" />
    </div>
</template>

<script>
import store from '@/store'
export default {
    data () {
        return {
            screenWidths: document.body.clientWidth,
        }
    },
    created () {},
    mounted () {
        const that = this;
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth;
                that.screenWidths = window.screenWidth;
            })();
        };
        // console.log('=====',that.screenWidths);
    },
    methods: {
    },
    watch: {
        /**
         * 监听屏幕宽度
         */
        screenWidths(val) {
            store.commit("setScreenWidth", val);
        },
    },
}
</script>
<style lang="scss"></style>
